import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cp0033',
    ecrans: ['00-2'],
    params: ['lorcleint']
});
